module.exports = __webpack_public_path__ + "img/2025-04-12c_3.57cd3f4c.jpg";